import { submitterLabel } from '../../utils/submitterName';

// Submitted remains a supported status but has no dedicated tab because classification normally
// completes in the submission request. It is included in the All total below.
export const IVR_TABS = ['All', 'Needs Review', 'Covered', 'Not Covered', 'Rejected'];

export const IVR_STATUS_CONFIG = {
  pending: { label: 'Submitted', bg: 'bg-[#fff8db]', text: 'text-[#c25e16]' },
  submitted: { label: 'Submitted', bg: 'bg-[#fff8db]', text: 'text-[#c25e16]' },
  covered: {
    label: 'Active Medicare Part B',
    bg: 'bg-[rgba(222,252,237,0.6)]',
    text: 'text-[#007a55]',
  },
  not_covered: { label: 'Medicare Advantage', bg: 'bg-[#fef9c3]', text: 'text-[#854d0e]' },
  rejected: { label: 'Rejected', bg: 'bg-[rgba(254,226,226,0.6)]', text: 'text-[#f23e41]' },
  needs_review: { label: 'Needs Review', bg: 'bg-[#f3e8ff]', text: 'text-[#7e22ce]' },
};

export const IVR_TAB_STATUS_KEY = {
  Submitted: 'submitted',
  'Needs Review': 'needs_review',
  Covered: 'covered',
  'Not Covered': 'not_covered',
  Rejected: 'rejected',
};

export function formatShortDate(value, locale = 'en-US') {
  if (!value) return '';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '';
  return parsed.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function decisionDate(record, locale = 'en-US') {
  return formatShortDate(record?.reviewedAt || record?.updatedAt, locale);
}

export function submitterName(record, t) {
  return submitterLabel(record?.submittedBy, t);
}

export function tabCount(tab, statusCounts = {}) {
  if (tab === 'All') {
    return Object.values(IVR_TAB_STATUS_KEY).reduce(
      (sum, key) => sum + (statusCounts[key] || 0),
      0
    );
  }
  return statusCounts[IVR_TAB_STATUS_KEY[tab]] || 0;
}
